import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Text } from '@pixi/react';

import { isMobile } from '../../../../../core/helpers/isMobile';
import { isoStandard } from '../../../../../core/helpers/isoStandard';
import { parseNumberByPrecision } from '../../../../../core/helpers/parseNumberByPrecision';

import { userInfoStore } from '../../../../../store/userInfoStore';
import { bettingPartStore } from '../../../../../store/bettingPartStore';
import { applicationStore } from '../../../../../store/applicationStore';

const PayTableSymbolOdds = observer(({ id, odd, oddX, oddY, oddIndex, oddContainerY }) => {
  const { currencyIcon, currencySymbol, precision } = userInfoStore;
  const { isShowLicenseMode, isDemo } = applicationStore;
  const { selectedQuickBet } = bettingPartStore;
  const handlePayTableInfoTextStyles = useCallback(() => {
    return {
      _fontSize: isMobile() ? 12 : 16,
      _fontWeight: 500,
      style: {
        fontFamily: 'poppinsMedium',
      },
    };
  }, []);

  return (
    <Container y={oddIndex * oddContainerY} name='PayTableSymbolOddContainer'>
      <Container name='PayTableSymbolOddRowContainer'>
        <Text
          resolution={2}
          text={id === 9 ? `${3 - oddIndex}x` : `${5 - oddIndex}x`}
          anchor={{ x: 1, y: 0.5 }}
          style={{ ...handlePayTableInfoTextStyles(), fill: '#FFFFFF' }}
        />
        <Text
          x={oddX}
          y={oddY}
          resolution={2}
          text={`${isShowLicenseMode && !isDemo ? currencyIcon : ''}${isoStandard(
            parseNumberByPrecision(odd, selectedQuickBet, precision)
          )} ${isShowLicenseMode && isDemo ? currencySymbol : ''}`}
          anchor={{ x: 0, y: 0.5 }}
          style={{ ...handlePayTableInfoTextStyles(), fill: '#FFC33E' }}
        />
      </Container>
    </Container>
  );
});

export default PayTableSymbolOdds;
